import { Injectable } from '@angular/core';
import * as _ from 'lodash';
import { CostCategories } from '../../../../assets/data/enum/costCategories';
import { TransactionDistribution } from '../../../../assets/data/enum/transactionDistribution';

@Injectable()
export class CostUtilsService {
  // customTab = new BehaviorSubject<string>('list')
  customTab = 0;
  // customTab$ = this.customTab.asObservable()
  constructor() {}

  // changeTab(tab: string) {
  //   this.customTab.next(tab)
  //  //  console.log(tab);
  //  //  console.log(this.customTab);
  // }

  getAllCategories = (): Array<string> => {
    const keys = _.sortBy(
      Object.keys(CostCategories).filter((k) => typeof CostCategories[k as any] === 'string')
    );
    const values = keys.map((k) => CostCategories[k as any]);
    return values;
  };

  getDiscountAmount = (cost: number, discount: number): number => {
    cost = cost ? cost : 0;
    discount = discount ? discount : 0;
    return (cost * discount) / 100;
  };

  getTotalPriceByUnit = (quantity: number, unitPrice: number): number => {
    quantity = quantity ? quantity : 0;
    unitPrice = unitPrice ? unitPrice : 0;
    return quantity * unitPrice;
  };

  getNetUnitPrice = (unitPrice: number, discount: number): number => {
    unitPrice = unitPrice ? unitPrice : 0;
    discount = discount ? discount : 0;

    if (discount) {
      return unitPrice - (unitPrice * discount) / 100;
    } else {
      return unitPrice;
    }
  };

  getNetYearPrice(
    unitPrice: number,
    discount: number,
    expectedLifeYears: number,
    dateOfPurchase: number,
    matriculationDate: number
  ): number {
    const years: number = expectedLifeYears - (dateOfPurchase - matriculationDate);
    unitPrice = unitPrice / years;
    discount = discount ? discount : 0;

    if (discount) {
      return unitPrice - (unitPrice * discount) / 100;
    } else {
      return unitPrice;
    }
  }

  getNetYearTotalPrice(
    quantity: number,
    unitPrice: number,
    discount: number,
    expectedLifeYears: number,
    dateOfPurchase: number,
    matriculationDate: number
  ): number {
    const years = expectedLifeYears - (dateOfPurchase - matriculationDate);
    quantity = quantity ? quantity : 0;
    unitPrice = unitPrice ? unitPrice / years : 0;

    unitPrice = quantity * unitPrice;

    if (discount) {
      return unitPrice - (unitPrice * discount) / 100;
    } else {
      return unitPrice;
    }
  }

  getNetRentPrice(unitPrice: number, discount: number, rent: number): number {
    unitPrice = unitPrice ? unitPrice / rent : 0;
    discount = discount ? discount : 0;

    if (discount) {
      return unitPrice - (unitPrice * discount) / 100;
    } else {
      return unitPrice;
    }
  }

  getNetYearFieldPrice(unitPrice: number, discount: number, expectedLifeYears: number): number {
    unitPrice = unitPrice ? unitPrice / expectedLifeYears : 0;
    discount = discount ? discount : 0;

    if (discount) {
      return unitPrice - (unitPrice * discount) / 100;
    } else {
      return unitPrice;
    }
  }

  getNetYearFieldTotalPrice(
    quantity: number,
    unitPrice: number,
    discount: number,
    expectedLifeYears: number
  ): number {
    quantity = quantity ? quantity : 0;
    unitPrice = unitPrice ? unitPrice / expectedLifeYears : 0;

    unitPrice = quantity * unitPrice;

    if (discount) {
      return unitPrice - (unitPrice * discount) / 100;
    } else {
      return unitPrice;
    }
  }

  getNetYearRentPrice(unitPrice: number, discount: number, yearMultiselect: number): number {
    unitPrice = unitPrice ? unitPrice * yearMultiselect : 0;
    discount = discount ? discount : 0;

    if (discount) {
      return unitPrice - (unitPrice * discount) / 100;
    } else {
      return unitPrice;
    }
  }

  getNetYearRentTotalPrice(
    quantity: number,
    unitPrice: number,
    discount: number,
    yearMultiselect: number
  ): number {
    unitPrice = unitPrice ? unitPrice * yearMultiselect : 0;
    discount = discount ? discount : 0;

    unitPrice = quantity * unitPrice;

    if (discount) {
      return unitPrice - (unitPrice * discount) / 100;
    } else {
      return unitPrice;
    }
  }

  sumColumnByKey = (list: Array<any>, key: string): number => {
    // tslint:disable-next-line:prefer-const
    let sum = 0;
    if (list && list.length > 0) {
      list.forEach((cost) => {
        if (key === 'quantity') {
          sum = sum + cost.quantity;
        } else if (key === 'total') {
          sum = sum + this.getTotalPriceByUnit(cost.quantity, cost.unitPrice);
        } else if (key === 'discountAmount') {
          sum =
            sum +
            this.getDiscountAmount(
              this.getTotalPriceByUnit(cost.quantity, cost.unitPrice),
              cost.discount
            );
        } else if (key === 'netTotal') {
          sum =
            sum +
            this.getTotalPriceByUnit(cost.quantity, cost.unitPrice) -
            this.getDiscountAmount(
              this.getTotalPriceByUnit(cost.quantity, cost.unitPrice),
              cost.discount
            );
        }
      });

      return sum;
    }
  };

  getAllTransactionDistribution = (): Array<string> => {
    const keys = _.sortBy(
      Object.keys(TransactionDistribution).filter(
        (k) => typeof TransactionDistribution[k as any] === 'string'
      )
    );
    const values = keys.map((k) => TransactionDistribution[k as any]);
    return values;
  };
}
